import axios from 'axios';
import _ from 'lodash';

function initQtyInput(el=null) {

    const validateQtyInputValue = (qtyInput, value) => {
        if(value > 99 || value < 1) {
            return false;
        }
        return true;
    }

    const productQty = el ? el.find('.product-qty') : $('.product-qty');

    productQty.each((i, el) => {
        el = $(el);
        if(el.attr('data-rendered') === true) {
            return;
        }
        const qtyInput = el.find('input');
        el.find('.btn-minus').on('click', () => {
            const newValue = parseInt(qtyInput.val()) - 1;
            if(validateQtyInputValue(qtyInput, newValue)) qtyInput.val(parseInt(newValue));
        });

        el.find('.btn-plus').on('click', () => {
            const newValue = parseInt(qtyInput.val()) + 1;
            if(validateQtyInputValue(qtyInput, newValue)) qtyInput.val(parseInt(newValue));
        });

        qtyInput.on('change', (e) => {
            const input = $(e.target).closest('input');
            const value = input.val();
            if(value > 99 || value < 1) {
                input.val(1);
            }
        });

        el.attr('data-rendered', true);

    });

}

export default initQtyInput;